(() => {
  const PRODUCT_PAGE_SELECTOR = '.legal-product-detail';
  let descriptionIndex = 0;

  const createIntro = ({ title, text }) => {
    const intro = document.createElement('header');
    intro.className = 'legal-pdp-section-intro';

    const titleElement = document.createElement('h2');
    titleElement.className = 'legal-pdp-section-intro__title';
    titleElement.textContent = title;

    const textElement = document.createElement('p');
    textElement.className = 'legal-pdp-section-intro__text';
    textElement.textContent = text;

    intro.append(titleElement, textElement);
    return intro;
  };

  const prependIntro = (container, content) => {
    if (!container || container.querySelector(':scope > .legal-pdp-section-intro')) return;
    container.prepend(createIntro(content));
  };

  const enhanceDescription = (scope) => {
    scope.querySelectorAll('.legal-product-detail .product-description').forEach((description, index) => {
      if (description.dataset.legalEnhanced === 'true' || description.textContent.trim().length < 190) return;
      description.dataset.legalEnhanced = 'true';
      description.classList.add('is-collapsible');

      const sectionId = description.closest('[data-section]')?.dataset.section || index;
      descriptionIndex += 1;
      const id = description.id || `LegalProductDescription-${sectionId}-${descriptionIndex}`;
      description.id = id;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'legal-description-toggle';
      button.setAttribute('aria-controls', id);
      button.setAttribute('aria-expanded', 'false');
      button.textContent = 'Lire la description';
      button.addEventListener('click', () => {
        const expanded = description.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? 'Réduire la description' : 'Lire la description';
      });

      description.insertAdjacentElement('afterend', button);
    });
  };

  const enhancePurchaseLayout = (scope) => {
    scope.querySelectorAll('.legal-product-detail').forEach((product) => {
      const leftColumn = product.querySelector('.column-left');
      const inventory = product.querySelector('.product-block--inventory');
      const price = product.querySelector('.product-block--price');
      if (leftColumn && inventory && price && price.parentElement === leftColumn && price.nextElementSibling !== inventory) {
        price.insertAdjacentElement('afterend', inventory);
      }
    });
  };

  const enhanceSections = (scope = document) => {
    const productPage = document.querySelector(PRODUCT_PAGE_SELECTOR);
    if (!productPage) return;
    document.body.classList.add('legal-pdp-ready');

    if (!productPage.classList.contains('legal-single-pdp')) {
      enhanceDescription(scope);
      enhancePurchaseLayout(scope);
    }

    scope.querySelectorAll('.tabs.page-width').forEach((tabs) => {
      prependIntro(tabs, {
        title: 'Tout savoir sur ce café',
        text: 'Préparation, profil aromatique et savoir-faire : les informations utiles, au même endroit.',
      });
    });

  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceSections());
  } else {
    enhanceSections();
  }

  document.addEventListener('shopify:section:load', (event) => enhanceSections(event.target));
})();
